import { render, staticRenderFns } from "./mainGroup.vue?vue&type=template&id=4e7d9f4b&scoped=true&"
import script from "./mainGroup.vue?vue&type=script&lang=js&"
export * from "./mainGroup.vue?vue&type=script&lang=js&"
import style0 from "./mainGroup.vue?vue&type=style&index=0&id=4e7d9f4b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7d9f4b",
  null
  
)

export default component.exports